import { QueryKeys } from "@Constants";
import { IActivityExportMetadataRequest } from "@Models/IActivityDetails";
import { IPointsMetadataRequest, PointsTypes } from "@Models/IPoints";
import ActivityService from "@Services/ActivityService";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useCreateMetadataForCPDReport = () => {
    const activityService = new ActivityService();
    const queryClient = useQueryClient();

    const {
        isLoading: isCreatingCPDPoints,
        isSuccess: hasCreatedCPDPoints,
        mutateAsync: createCPDPoints,
        reset: resetCPDCreationStatus,
    } = useMutation(
        async ({ req }: { req: IPointsMetadataRequest }) =>
            await activityService.createPointsMetadata({ ...req, pointsType: PointsTypes.CPD }),
        {
            onSuccess: async (res) => {
                if (res.value?.id) {
                    await queryClient.invalidateQueries([QueryKeys.PointsTableData, PointsTypes.CPD]);
                }
            },
        }
    );

    return { createCPDPoints, isCreatingCPDPoints, hasCreatedCPDPoints, resetCPDCreationStatus };
};

export const useCreateActivityExportMetadata = () => {
    const activityService = new ActivityService();
    const queryClient = useQueryClient();

    return useMutation(
        ({ req }: { req: IActivityExportMetadataRequest }) => activityService.createExportMetadata(req),
        {
            onSuccess: async (res) => {
                if (res.value.id) {
                    await queryClient.invalidateQueries([QueryKeys.ExportMetadata]);
                }
            },
        }
    );
};
